/**
 * An implementation of IUISurvey based on floodgate.core INpsSurvey
 */
import * as Api from "@ms-ofb/officefloodgatecore/dist/src/Api/Api";
export default class UISurvey {
  constructor(survey) {
    this.showPrompt = true;
    this.showEmailRequest = false;
    if (!survey) {
      throw Error("survey must not be null");
    } else {
      this.survey = survey;
    }
    if (survey.getType() === Api.ISurvey.Type.Intercept) {
      this.isIntercept = true;
      let interceptComponent = survey.getComponent("Intercept" /* Intercept */);
      if (interceptComponent) {
        this.intercept = interceptComponent;
      } else {
        throw Error("intercept component must not be null");
      }
    } else {
      this.isIntercept = false;
      let promptComponent = survey.getComponent("Prompt" /* Prompt */);
      let commentComponent = survey.getComponent("Comment" /* Comment */);
      let ratingComponent = survey.getComponent("Rating" /* Rating */);
      if (promptComponent) {
        this.prompt = promptComponent;
      } else {
        throw Error("prompt component must not be null");
      }
      // Check for additonalDataRequested options
      this.showEmailRequest = survey.getSurveyInfo().isAdditionalDataRequested(0 /* EmailAddress */);
      if (commentComponent) {
        this.comment = commentComponent;
      } else {
        throw Error("comment component must not be null");
      }
      if (ratingComponent) {
        this.rating = ratingComponent;
      } else {
        throw Error("rating component must not be null");
      }
    }
  }
  getPromptQuestion() {
    return this.isIntercept ? undefined : this.prompt.getQuestion();
  }
  getTitle() {
    return this.isIntercept ? undefined : this.prompt.getTitle();
  }
  getPromptYesButtonText() {
    return this.isIntercept ? undefined : this.prompt.getYesButtonText();
  }
  getPromptNoButtonText() {
    return this.isIntercept ? undefined : this.prompt.getNoButtonText();
  }
  getRatingValuesAscending() {
    return this.isIntercept ? undefined : this.rating.getRatingValuesAscending();
  }
  getRatingQuestion() {
    return this.isIntercept ? undefined : this.rating.getQuestion();
  }
  getCommentQuestion() {
    return this.isIntercept ? undefined : this.comment.getQuestion();
  }
  getInterceptTitle() {
    return this.isIntercept ? this.intercept.getTitle() : undefined;
  }
  getInterceptQuestion() {
    return this.isIntercept ? this.intercept.getQuestion() : undefined;
  }
  getInterceptUrl() {
    return this.isIntercept ? this.intercept.getUrl() : undefined;
  }
  setValues(selectedIndex, comment) {
    if (!this.isIntercept) {
      this.rating.setSelectedRatingIndex(selectedIndex);
      this.comment.setSubmittedText(comment);
    }
  }
  getJsonElements() {
    return this.survey.getJsonElements();
  }
  getSurveyType() {
    return this.survey.getType();
  }
  getCampaignId() {
    return this.survey.getSurveyInfo().getBackEndId();
  }
  getId() {
    return this.survey.getSurveyInfo().getId();
  }
}